import type { z } from 'zod';

import { Decimal } from './decimal';

export const HouseholdIncome = Decimal;

export type HouseholdIncome = z.infer<typeof HouseholdIncome>;
